import {mergeDeepObject} from "./util";

let defaultSettings = {
	rowSelector: "> li",
	submenuSelector: "*",
	submenuDirection: "right",
	tolerance: 75,  // больше = больше настроек при входе в подменю
	enter: function () {},
	exit: function () {},
	activate: function () {},
	deactivate: function () {},
	exitMenu: function () {}
}

class VGMenuAim {
	constructor(element, opts) {
		this.element = element;
		this.activeRow = null;
		this.mouseLocs = [];
		this.lastDelayLoc = null;
		this.timeoutId = null;

		this.options = mergeDeepObject(defaultSettings, opts);
		this.init();
	}

	init() {
		let _this = this;

		let MOUSE_LOCS_TRACKED = 3,  // количество прошлых местоположений мыши для отслеживания
			DELAY = 300;  // секундная задержка, когда кажется, что пользователь входит в подменю

		/**
		 * Следим за несколькими последними перемещениями мыши.
		 */
		let mousemoveDocument = function(e) {
			_this.mouseLocs.push({x: e.pageX, y: e.pageY});

			if (_this.mouseLocs.length > MOUSE_LOCS_TRACKED) {
				_this.mouseLocs.shift();
			}
		};

		/**
		 * Отменим возможные активации строк при полном выходе из меню
		 */
		let mouseleaveMenu = function() {
			if (_this.timeoutId) {
				clearTimeout(_this.timeoutId);
			}

			// Если указано меню выхода и возвращается значение true, деактивируйте
			// активную в данный момент строку при выходе из меню.
			if (_this.options.exitMenu(this)) {
				if (_this.activeRow) {
					_this.options.deactivate(_this.activeRow);
				}

				_this.activeRow = null;
			}
		};

		/**
		 * Запускаем возможную активацию строки при каждом вводе новой строки.
		 */
		let mouseenterRow = function() {
				if (_this.timeoutId) {
					// Cancel any previous activation delays
					clearTimeout(_this.timeoutId);
				}

				_this.options.enter(this);
				possiblyActivate(this);
			},
			mouseleaveRow = function() {
				_this.options.exit(this);
			};

		/*
		 * Немедленно активируем строку, если пользователь нажмет на нее.
		 */
		let clickRow = function() {
			activate(this);
		};

		/**
		 * Активируем строку меню.
		 */
		let activate = function(row) {
			if (row === _this.activeRow) {
				return;
			}

			if (_this.activeRow) {
				_this.options.deactivate(_this.activeRow);
			}

			_this.options.activate(row);
			_this.activeRow = row;
		};

		/**
		 * Возможно, активировать строку меню. Если движение мыши указывает на то, что мы
		 * пока не должны активировать, потому что пользователь, возможно, пытается ввести
		 * содержимое подменю, отложите и проверьте еще раз позже.
		 */
		let possiblyActivate = function(row) {
			let delay = activationDelay();

			if (delay) {
				_this.timeoutId = setTimeout(function() {
					possiblyActivate(row);
				}, delay);
			} else {
				activate(row);
			}
		};

		/**
		 * Возвращает количество времени, которое должно быть использовано в качестве задержки перед активацией строки,
		 * в которой в данный момент находится зависшая строка.
		 *
		 * Возвращает 0, если активация должна произойти немедленно. Иначе,
		 * возвращает количество миллисекунд, которое должно быть отложено до
		 * еще раз проверяем, следует ли активировать строку.
		 */
		let activationDelay = function() {
			if (!_this.activeRow ) {
				// Если ни одна другая строка подменю не активирована, то
				// активируйте ее немедленно.
				return 0;
			}

			let rect = _this.element.getBoundingClientRect(),
				offset = {
					top: rect.top + window.scrollY,
					left: rect.left + window.scrollX,
				};

			let upperLeft = {
					x: offset.left,
					y: offset.top - _this.options.tolerance
				},
				upperRight = {
					x: offset.left + _this.element.clientWidth,
					y: upperLeft.y
				},
				lowerLeft = {
					x: offset.left,
					y: offset.top + _this.element.clientHeight + _this.options.tolerance
				},
				lowerRight = {
					x: offset.left + _this.element.clientWidth,
					y: lowerLeft.y
				},
				loc = _this.mouseLocs[_this.mouseLocs.length - 1],
				prevLoc = _this.mouseLocs[0];

			if (!loc) {
				return 0;
			}

			if (!prevLoc) {
				prevLoc = loc;
			}

			if (prevLoc.x < offset.left || prevLoc.x > lowerRight.x ||
				prevLoc.y < offset.top || prevLoc.y > lowerRight.y) {
				// Если предыдущее положение мыши было за пределами всего меню,
				// немедленно активируйте его.
				return 0;
			}

			if (_this.lastDelayLoc &&
				loc.x === _this.lastDelayLoc.x && loc.y === _this.lastDelayLoc.y) {
				// Если мышь не двигалась с момента последней проверки
				// для получения статуса активации немедленно активируйте.
				return 0;
			}

			// Определяет, движется ли пользователь к активированному в данный момент подменю.
			//
			// Если мышь относительно четко движется в направлении
			// // содержимое подменю, мы должны подождать и предоставить пользователю больше
			// время перед активацией новой строки. Если курсор мыши находится в
			// другом месте мы можем немедленно активировать новую строку.
			//
			// Мы определяем это, вычисляя наклон, образовавшийся между
			// текущим местоположением мыши и верхними/нижними правыми точками
			// меню. Мы делаем то же самое для предыдущего местоположения мыши.
			// // Если текущие наклоны положения мыши равны
			// увеличивая/уменьшая соответствующим образом по сравнению с предыдущим,
			// мы знаем, что пользователь переходит к подменю.
			//
			// Обратите внимание, что, поскольку ось y увеличивается при перемещении курсора
			// перемещаясь вниз по экрану, мы следим за тем, чтобы наклон между курсором
			// и правым верхним углом со временем уменьшался, а не
			// увеличивался (что несколько противоречит здравому смыслу).
			function slope(a, b) {
				return (b.y - a.y) / (b.x - a.x);
			}

			let decreasingCorner = upperRight,
				increasingCorner = lowerRight;

			// Мы ожидаем уменьшения или увеличения значений наклона
			// зависит от того, в каком направлении открывается подменю относительно
			// главного меню. По умолчанию, если меню открывается справа, мы
			// ожидаем, что наклон будет находиться между курсором и верхним правым углом
			// угол должен уменьшаться со временем, как описано выше. Если подменю
			// открывается в другом направлении, мы меняем угол наклона ожидания.
			if (_this.options.submenuDirection === "left") {
				decreasingCorner = lowerLeft;
				increasingCorner = upperLeft;
			} else if (_this.options.submenuDirection === "below") {
				decreasingCorner = lowerRight;
				increasingCorner = lowerLeft;
			} else if (_this.options.submenuDirection === "above") {
				decreasingCorner = upperLeft;
				increasingCorner = upperRight;
			}

			let decreasingSlope = slope(loc, decreasingCorner),
				increasingSlope = slope(loc, increasingCorner),
				prevDecreasingSlope = slope(prevLoc, decreasingCorner),
				prevIncreasingSlope = slope(prevLoc, increasingCorner);

			if (decreasingSlope < prevDecreasingSlope &&
				increasingSlope > prevIncreasingSlope) {
				// Мышь перемещается с предыдущего места к
				// активированному в данный момент подменю. Задержка перед активацией
				// новой строки меню, поскольку пользователь, возможно, переходит в подменю.
				_this.lastDelayLoc = loc;
				return DELAY;
			}

			_this.lastDelayLoc = null;
			return 0;
		};

		/**
		 * Подключение событий начального меню
		 */
		_this.element.addEventListener('mouseleave', mouseleaveMenu);
		_this.element.childNodes.forEach(function (item) {
			item.addEventListener('mouseenter', mouseenterRow);
			item.addEventListener('mouseleave', mouseleaveRow);
			item.addEventListener('click', clickRow);
		});

		document.addEventListener('mousemove', mousemoveDocument);
	}
}

export default VGMenuAim;
